import React, { useState, useEffect } from 'react';
import { BookOpenIcon, LockClosedIcon } from '@heroicons/react/24/solid';
import BottomNav from '../components/mobile/BottomNav';
import { useTranslations } from '../hooks/useTranslations';
import lecture1 from '../assets/lectures/1.1 Lecture 1 - Course Objectives & Teaching Approach.pdf';
import lecture2 from '../assets/lectures/2.1 Lecutre 2 - Why Be Involved In The Markets.pdf';
import lecture3 from '../assets/lectures/3.1 Lecture 3 -What Is A Stock.pdf';
import lecture4 from '../assets/lectures/4.1 Lecture 4 - What Is A Market.pdf';
import lecture5 from '../assets/lectures/5.1 Lecture 5 - What Is A Stock Exchange.pdf';
import lecture6 from '../assets/lectures/6.1 Lecture 6 - What Is a Broker.pdf';
import lecture7 from '../assets/lectures/7.1 Lecture 7 - Orders And Order Types.pdf';
import lecture8 from '../assets/lectures/8.1 Lecture 8 - Orders Driving Prices (Level1 - Level2 - Time and Sales).pdf';
import lecture9 from '../assets/lectures/9.1 Lecture 9 - Different Players.pdf';
import lecture10 from '../assets/lectures/10.1 Lecture 10 - 3 Ways of Making Money - Market Sentiment & Contrarian Investing.pdf';
import lecture11 from '../assets/lectures/11.1 Lecture 20 - Expectancy.pdf';
import lecture12 from '../assets/lectures/12.1 Lecture 21 - Gambling vs Educated Betting.pdf';
import lecture13 from '../assets/lectures/13.1 Lecture 23 - Risk Management.pdf';
import lecture14 from '../assets/lectures/14.1 Lecture 24 - Money Management.pdf';

function Lectures() {
  const { t } = useTranslations();
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const lectures = [
    { id: 1, title: t('lectures.lectures.0.title'), file: lecture1 },
    { id: 2, title: t('lectures.lectures.1.title'), file: lecture2 },
    { id: 3, title: t('lectures.lectures.2.title'), file: lecture3 },
    { id: 4, title: t('lectures.lectures.3.title'), file: lecture4 },
    { id: 5, title: t('lectures.lectures.4.title'), file: lecture5 },
    { id: 6, title: t('lectures.lectures.5.title'), file: lecture6 },
    { id: 7, title: t('lectures.lectures.6.title'), file: lecture7 },
    { id: 8, title: t('lectures.lectures.7.title'), file: lecture8 },
    { id: 9, title: t('lectures.lectures.8.title'), file: lecture9 },
    { id: 10, title: t('lectures.lectures.9.title'), file: lecture10 },
    { id: 11, title: t('lectures.lectures.10.title'), file: lecture11 },
    { id: 12, title: t('lectures.lectures.11.title'), file: lecture12 },
    { id: 13, title: t('lectures.lectures.12.title'), file: lecture13 },
    { id: 14, title: t('lectures.lectures.13.title'), file: lecture14 },
  ];

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsLoading(false);
        return;
      }
      try {
        const response = await fetch("https://api.maxprofitacademy.com/user", {
          method: "GET",
          headers: { "token": JSON.parse(token) }
        });
        const data = await response.json();
        if (data.status === 200) {
          setUserData(data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const hasValidCourse = userData?.course && ['GOLD', 'SILVER', 'PLATINUM'].includes(userData.course.toUpperCase());

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        <span className="ml-3 text-gray-600">{t('lectures.loading')}</span>
      </div>
    );
  }
  
  if (!hasValidCourse) {
    return (
      <div className=" flex flex-col items-center justify-center">
        <div className="bg-primary/10 mt-10 p-6 rounded-2xl mb-6 flex items-center justify-center">
          <BookOpenIcon className="w-12 h-12 text-primary mr-4" />
          <span className="text-xl font-semibold text-gray-700">{t('lectures.noAccessTitle')}</span>
        </div>
        <BottomNav />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
      {lectures.map((lec) => (
        <div key={lec.id} className="bg-white rounded-3xl p-6 flex shadow-sm hover:shadow-md transition-shadow">
          <div className="md:w-1/3 w-20 flex items-center justify-center">
            <div className="bg-primary/10 p-4 rounded-xl">
              <BookOpenIcon className="w-full h-full text-primary" />
            </div>
          </div>
          <div className="w-2/3 pl-6 flex flex-col">
            <h3 className="md:text-xl text-base font-semibold mb-2 text-black">{lec.title}</h3>
            {/* <p className="text-gray-600 md:text-sm text-xs flex-grow">Описание лекции (если появится)</p> */}
            {hasValidCourse ? (
              <a
                href={lec.file}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 flex items-center text-[12px] md:text-[18px] justify-center space-x-2 bg-primary text-black px-4 py-2 rounded-xl hover:bg-primary/90 transition-colors"
              >
                <BookOpenIcon className="w-5 h-5" />
                <span>{t('lectures.downloadPdf')}</span>
              </a>
            ) : (
              <button
                className="mt-4 flex items-center text-[12px] md:text-[18px] justify-center space-x-2 bg-gray-100 text-gray-500 px-4 py-2 rounded-xl hover:bg-gray-200 transition-colors"
                disabled
              >
                <LockClosedIcon className="w-5 h-5" />
                <span>{t('lectures.unavailable')}</span>
              </button>
            )}
          </div>
        </div>
      ))}
      <BottomNav />
    </div>
  );
}

export default Lectures; 